// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"css_loadingWrapper__fnVBW"};